module.exports = __webpack_public_path__ + "files/734c28f9c7e5c1d5415c5b7ef3066962.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-3.png
// module id = 499
// module chunks = 76